/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * Nestjs FTW
 * The Client Portal API description
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
export type NotificationControllerUpdateMyNotificationsParams = {
isRead: boolean;
id?: string;
};

export type GetManyBaseNotificationControllerNotificationEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseRequestHistoryControllerRequestHistoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseUserControllerUserEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseUserControllerUserEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type UserControllerUpdateClientOfUsersParams = {
clientId: string;
userIds: string[];
};

export type GetOneBaseTemplateTypeControllerTemplateTypeEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseTemplateTypeControllerTemplateTypeEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseTemplateControllerTemplateEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseTemplateControllerTemplateEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type RequestControllerCheckContractorParams = {
contractor: string;
};

export type RequestControllerRejectRequestParams = {
reason: string;
};

export type RequestControllerApproveRequestParams = {
reason: string;
};

export type GetOneBaseRequestControllerRequestEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseRequestControllerRequestEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type RequestCandidateControllerRejectRequestCandidateParams = {
ids: string[];
reason: string;
};

export type RequestCandidateControllerApproveRequestCandidateParams = {
ids: string[];
reason: string;
};

export type RequestCandidateControllerUpdateStatusStatus = typeof RequestCandidateControllerUpdateStatusStatus[keyof typeof RequestCandidateControllerUpdateStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateControllerUpdateStatusStatus = {
  New: 'New',
  InProgress: 'InProgress',
  Review: 'Review',
  Published: 'Published',
  Cancelled: 'Cancelled',
  Pending: 'Pending',
} as const;

export type RequestCandidateControllerUpdateStatusParams = {
status: RequestCandidateControllerUpdateStatusStatus;
};

export type RequestCandidateControllerSubmitForReviewParams = {
ids: string[];
};

export type GetOneBaseRequestCandidateControllerRequestCandidateEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseRequestCandidateControllerRequestCandidateEntityParams = {
isGetAll?: boolean;
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseLogControllerLogEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseLogControllerLogEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseFieldControllerFieldEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseFieldControllerFieldEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseClientUserControllerClientUserEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type ClientUserControllerConfigCustomerUserParams = {
userId: string;
};

export type GetOneBaseClientControllerClientEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseClientControllerClientEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type MultiChecklistControllerGetChecklistFilesParams = {
ids?: string[];
};

export type GetOneBaseChecklistControllerChecklistEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetOneBaseCategoryControllerCategoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export type GetManyBaseCategoryControllerCategoryEntityParams = {
/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
fields?: string[];
/**
 * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
 */
s?: string;
/**
 * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
 */
filter?: string[];
/**
 * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
 */
or?: string[];
/**
 * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
 */
sort?: string[];
/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
join?: string[];
/**
 * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
 */
limit?: number;
/**
 * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
 */
offset?: number;
/**
 * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
 */
page?: number;
/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
cache?: number;
/**
 * Include deleted. <a href="https://github.com/nestjsx/crud/wiki/Requests#includeDeleted" target="_blank">Docs</a>
 */
include_deleted?: number;
};

export interface CategoryFieldEntity {
  category?: CategoryEntity;
  categoryId: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  field?: FieldEntity;
  fieldId: string;
  hasOriginalValue: boolean;
  hasResultValue: boolean;
  hasVerifiedValue: boolean;
  id?: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface TemplateCategoryEntity {
  category?: CategoryEntity;
  categoryId: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  id?: string;
  index?: number;
  numberOfGroup: number;
  template?: TemplateEntity;
  templateId: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface TemplateCategoryFieldEntity {
  category?: CategoryEntity;
  categoryId: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  defaultValue?: string;
  deletedAt?: string;
  field?: FieldEntity;
  fieldId: string;
  id?: string;
  index?: number;
  isRequired: boolean;
  template?: TemplateEntity;
  templateCategory?: TemplateCategoryEntity;
  templateCategoryId?: string;
  templateId: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyNotificationEntityResponseDTO {
  count: number;
  data: NotificationEntity[];
  hasNextPage: boolean;
  page: number;
  pageCount: number;
  total: number;
}

export type NotificationEntityTargetType = typeof NotificationEntityTargetType[keyof typeof NotificationEntityTargetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationEntityTargetType = {
  Request: 'Request',
  RequestCandidate: 'RequestCandidate',
  RequestCandidateDetail: 'RequestCandidateDetail',
} as const;

export type NotificationEntityActionType = typeof NotificationEntityActionType[keyof typeof NotificationEntityActionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationEntityActionType = {
  Info: 'Info',
  Approve: 'Approve',
  Reject: 'Reject',
} as const;

export interface NotificationEntity {
  actionType: NotificationEntityActionType;
  content?: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  id?: string;
  readAt?: string;
  targetId?: string;
  targetType: NotificationEntityTargetType;
  title: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
  user: UserEntity;
  userId: string;
}

export interface GetManyNotificationEntityResponseDto {
  count: number;
  data: NotificationEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type RequestCandidateHistoryEntityToStatus = typeof RequestCandidateHistoryEntityToStatus[keyof typeof RequestCandidateHistoryEntityToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateHistoryEntityToStatus = {
  New: 'New',
  InProgress: 'InProgress',
  Review: 'Review',
  Published: 'Published',
  Cancelled: 'Cancelled',
  Pending: 'Pending',
} as const;

export type RequestCandidateHistoryEntityFromStatus = typeof RequestCandidateHistoryEntityFromStatus[keyof typeof RequestCandidateHistoryEntityFromStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateHistoryEntityFromStatus = {
  New: 'New',
  InProgress: 'InProgress',
  Review: 'Review',
  Published: 'Published',
  Cancelled: 'Cancelled',
  Pending: 'Pending',
} as const;

export type RequestCandidateHistoryEntityAction = typeof RequestCandidateHistoryEntityAction[keyof typeof RequestCandidateHistoryEntityAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateHistoryEntityAction = {
  Created: 'Created',
  SubmittedForReview: 'SubmittedForReview',
  Rejected: 'Rejected',
  Approved: 'Approved',
  ChangedStatus: 'ChangedStatus',
} as const;

export interface RequestCandidateHistoryEntity {
  action: RequestCandidateHistoryEntityAction;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  fromStatus: RequestCandidateHistoryEntityFromStatus;
  id?: string;
  reason?: string;
  requestCandidateId: string;
  toStatus: RequestCandidateHistoryEntityToStatus;
  updatedAt?: string;
  updatedById?: string;
}

export interface GetManyRequestCandidateHistoryEntityResponseDto {
  count: number;
  data: RequestCandidateHistoryEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type RequestHistoryEntityToStatus = typeof RequestHistoryEntityToStatus[keyof typeof RequestHistoryEntityToStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestHistoryEntityToStatus = {
  Draft: 'Draft',
  New: 'New',
  InProgress: 'InProgress',
  WaitingForApproval: 'WaitingForApproval',
  Rejected: 'Rejected',
  Done: 'Done',
} as const;

export type RequestHistoryEntityFromStatus = typeof RequestHistoryEntityFromStatus[keyof typeof RequestHistoryEntityFromStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestHistoryEntityFromStatus = {
  Draft: 'Draft',
  New: 'New',
  InProgress: 'InProgress',
  WaitingForApproval: 'WaitingForApproval',
  Rejected: 'Rejected',
  Done: 'Done',
} as const;

export type RequestHistoryEntityAction = typeof RequestHistoryEntityAction[keyof typeof RequestHistoryEntityAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestHistoryEntityAction = {
  Created: 'Created',
  Updated: 'Updated',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Requested: 'Requested',
} as const;

export interface RequestHistoryEntity {
  action: RequestHistoryEntityAction;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  fromStatus: RequestHistoryEntityFromStatus;
  id?: string;
  reason?: string;
  requestId: string;
  toStatus: RequestHistoryEntityToStatus;
  updatedAt?: string;
  updatedById?: string;
}

export interface GetManyRequestHistoryEntityResponseDto {
  count: number;
  data: RequestHistoryEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface CreateTemplateFieldInput {
  fieldId: string;
  isRequired: boolean;
}

export interface CreateTemplateCategoryInput {
  categoryId: string;
  fields: CreateTemplateFieldInput[];
}

export interface CreateTemplateInput {
  categories: CreateTemplateCategoryInput[];
  template: TemplateEntity;
}

export interface CreateRequestInput {
  assigneeIds?: string[];
  request: RequestEntity;
}

export type LogEntityAction = typeof LogEntityAction[keyof typeof LogEntityAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogEntityAction = {
  Create: 'Create',
  Update: 'Update',
  Delete: 'Delete',
  Download: 'Download',
} as const;

export interface LogEntity {
  action: LogEntityAction;
  createdAt?: string;
  data: string;
  deletedAt?: string;
  id?: string;
  threadName: string;
  updatedAt?: string;
  userEmail: string;
  userFullName: string;
}

export interface GetManyLogEntityResponseDto {
  count: number;
  data: LogEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface CreateFieldInput {
  categories?: string[];
  field: FieldEntity;
}

export interface CreateCustomerUserInput {
  customerEmail: string;
  customerId: string;
  customerName: string;
}

export type ChecklistCategoryFieldInputBackgroundColor = typeof ChecklistCategoryFieldInputBackgroundColor[keyof typeof ChecklistCategoryFieldInputBackgroundColor];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChecklistCategoryFieldInputBackgroundColor = {
  Green: 'Green',
  Yellow: 'Yellow',
  Red: 'Red',
} as const;

export interface ChecklistCategoryFieldInput {
  backgroundColor?: ChecklistCategoryFieldInputBackgroundColor;
  checklistCategoryFieldId?: string;
  fieldId?: string;
  isRequired?: boolean;
  originalValue?: string;
  resultValue?: string;
  verifiedValue?: string;
}

export interface ChecklistCategoryGroupFieldInput {
  checklistCategoryFields: ChecklistCategoryFieldInput[];
  groupId: string;
}

export interface FilesUploadDTO {
  files: Blob[];
}

export interface FileUploadDTO {
  file: Blob;
}

export interface ChecklistCategoryEntity {
  category?: CategoryEntity;
  categoryId?: string;
  checklist?: ChecklistEntity;
  checklistId?: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  finalConclusionName?: string;
  finalConclusionValue?: string;
  id?: string;
  index?: number;
  isComplete: boolean;
  numberOfGroup?: number;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
  verifiedAt?: string;
  verifiedBy?: UserEntity;
  verifiedByEmail?: string;
  verifiedById?: string;
  verifiedByName?: string;
}

export interface ChecklistCategoryInput {
  checklistCategory: ChecklistCategoryEntity;
  checklistCategoryFields?: ChecklistCategoryFieldInput[];
  groups?: ChecklistCategoryGroupFieldInput[];
}

export interface ChecklistCategoryGroupEntity {
  category?: CategoryEntity;
  categoryId: string;
  checklist?: ChecklistEntity;
  checklistCategory?: ChecklistCategoryEntity;
  checklistCategoryId?: string;
  checklistId: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  id?: string;
  index: number;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface ChecklistCategoryFieldEntity {
  backgroundColor?: ColorOption;
  category: CategoryEntity;
  categoryId: string;
  checklist: ChecklistEntity;
  checklistCategory?: ChecklistCategoryEntity;
  checklistCategoryId?: string;
  checklistId: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  field: FieldEntity;
  fieldId: string;
  group?: ChecklistCategoryGroupEntity;
  groupId?: string;
  id?: string;
  index?: number;
  isRequired: boolean;
  originalValue?: string;
  resultValue?: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
  verifiedValue?: string;
}

export interface GroupChecklistCategoryOutput {
  checklistCategoryFields: ChecklistCategoryFieldEntity[];
  groupId: string;
}

export interface ChecklistCategoryOutput {
  category: CategoryEntity;
  categoryId: string;
  checklistCategoryFields: ChecklistCategoryFieldEntity[];
  checklistId: string;
  groups: GroupChecklistCategoryOutput[];
  id: string;
  index: number;
  isComplete: boolean;
  numberOfGroup: number;
  verifiedAt?: string;
  verifiedBy: UserEntity;
  verifiedByEmail?: string;
  verifiedById?: string;
  verifiedByName?: string;
}

export interface GetManyChecklistCategoryEntityResponseDto {
  count: number;
  data: ChecklistCategoryEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type FieldEntityType = typeof FieldEntityType[keyof typeof FieldEntityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldEntityType = {
  Text: 'Text',
  TextArea: 'TextArea',
  Number: 'Number',
  DateTime: 'DateTime',
  Year: 'Year',
  PhoneNumber: 'PhoneNumber',
  Email: 'Email',
  DropdownList: 'DropdownList',
  CheckboxList: 'CheckboxList',
  Label: 'Label',
  EditorArea: 'EditorArea',
  ColorOption: 'ColorOption',
} as const;

export type FieldEntityStatus = typeof FieldEntityStatus[keyof typeof FieldEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FieldEntityStatus = {
  Active: 'Active',
  InActive: 'InActive',
} as const;

export interface FieldEntity {
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  defaultValue?: string | null;
  deletedAt?: string;
  description?: string | null;
  displayName?: string | null;
  hasOriginalValue: boolean;
  hasResultValue: boolean;
  hasVerifiedValue: boolean;
  id?: string;
  listValue?: string | null;
  name: string;
  nameUnAccent?: string;
  status: FieldEntityStatus;
  type: FieldEntityType;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyFieldEntityResponseDto {
  count: number;
  data: FieldEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type ColorOption = typeof ColorOption[keyof typeof ColorOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColorOption = {
  Green: 'Green',
  Yellow: 'Yellow',
  Red: 'Red',
} as const;

export interface ChecklistEntity {
  code?: string | null;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  fileUrl?: string | null;
  id?: string;
  name?: string;
  requestCandidate?: RequestCandidateEntity;
  requestCandidateId: string;
  template?: TemplateEntity;
  templateId: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export type RequestCandidateEntityStatus = typeof RequestCandidateEntityStatus[keyof typeof RequestCandidateEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateEntityStatus = {
  New: 'New',
  InProgress: 'InProgress',
  Review: 'Review',
  Published: 'Published',
  Cancelled: 'Cancelled',
  Pending: 'Pending',
} as const;

export type RequestCandidateEntityLevel = typeof RequestCandidateEntityLevel[keyof typeof RequestCandidateEntityLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestCandidateEntityLevel = {
  Intern: 'Intern',
  TTP: 'TTP',
  Trainee: 'Trainee',
  Assistant: 'Assistant',
  Consultant: 'Consultant',
  SeniorConsultant: 'SeniorConsultant',
  Supervisor: 'Supervisor',
  AssociateManager: 'AssociateManager',
  Manager: 'Manager',
  AssociateDirector: 'AssociateDirector',
  Director: 'Director',
  DeputyCEO: 'DeputyCEO',
  CEO: 'CEO',
  JuniorPrincipal: 'JuniorPrincipal',
  AssociatePrincipal: 'AssociatePrincipal',
  Principal: 'Principal',
  SeniorPrincipal: 'SeniorPrincipal',
} as const;

export interface RequestCandidateEntity {
  candidateInfo?: string;
  candidateName: string;
  candidateNameUnAccent?: string;
  checklists?: ChecklistEntity[];
  code?: string | null;
  consentForm?: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  dateOfBirth?: string;
  degree?: string;
  deletedAt?: string;
  description?: string | null;
  dueDate?: string;
  email?: string;
  fileUrl: string;
  id?: string;
  level?: RequestCandidateEntityLevel;
  obDate?: string;
  phoneNumber?: string;
  position?: string;
  request?: RequestEntity;
  requestId: string;
  status: RequestCandidateEntityStatus;
  template?: TemplateEntity;
  templateId?: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export type RequestEntityStatus = typeof RequestEntityStatus[keyof typeof RequestEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestEntityStatus = {
  Draft: 'Draft',
  New: 'New',
  InProgress: 'InProgress',
  WaitingForApproval: 'WaitingForApproval',
  Rejected: 'Rejected',
  Done: 'Done',
} as const;

export interface RequestAssigneeEntity {
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  id?: string;
  request?: RequestEntity;
  requestId: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
  user?: UserEntity;
  userId: string;
}

export interface RequestEntity {
  client?: ClientEntity;
  clientId?: string | null;
  code?: string | null;
  contractor?: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  dueDate?: string;
  id?: string;
  name: string;
  nameUnAccent?: string;
  pic?: UserEntity;
  picId?: string | null;
  requestAssignees?: RequestAssigneeEntity[];
  requestor?: string | null;
  status: RequestEntityStatus;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyRequestEntityResponseDto {
  count: number;
  data: RequestEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyRequestCandidateEntityResponseDto {
  count: number;
  data: RequestCandidateEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type TemplateEntityStatus = typeof TemplateEntityStatus[keyof typeof TemplateEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateEntityStatus = {
  Active: 'Active',
  InActive: 'InActive',
} as const;

export type TemplateTypeEntityStatus = typeof TemplateTypeEntityStatus[keyof typeof TemplateTypeEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TemplateTypeEntityStatus = {
  Active: 'Active',
  InActive: 'InActive',
} as const;

export interface TemplateTypeEntity {
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  id?: string;
  name: string;
  nameUnAccent?: string;
  status: TemplateTypeEntityStatus;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface TemplateEntity {
  client?: ClientEntity;
  clientId?: string | null;
  clientLogo?: string | null;
  code?: string | null;
  companyLogo?: string | null;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  id?: string;
  instruction?: string | null;
  name: string;
  nameUnAccent?: string;
  status: TemplateEntityStatus;
  templateType?: TemplateTypeEntity;
  templateTypeId?: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyTemplateTypeEntityResponseDto {
  count: number;
  data: TemplateTypeEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyTemplateEntityResponseDto {
  count: number;
  data: TemplateEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyChecklistEntityResponseDto {
  count: number;
  data: ChecklistEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface CreateCategoryInput {
  category: CategoryEntity;
  fields?: string[];
}

export type CategoryEntityType = typeof CategoryEntityType[keyof typeof CategoryEntityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CategoryEntityType = {
  CandidateInformation: 'CandidateInformation',
  ExecutiveSummary: 'ExecutiveSummary',
  EducationalQualificationCheck: 'EducationalQualificationCheck',
  EducationCheck: 'EducationCheck',
  ProfessionalQualificationCheck: 'ProfessionalQualificationCheck',
  ReferenceCheck: 'ReferenceCheck',
  MediaSearch: 'MediaSearch',
  SocialCheck: 'SocialCheck',
  SpecialCategory: 'SpecialCategory',
  CreditRecord: 'CreditRecord',
  CriminalCheck: 'CriminalCheck',
} as const;

export type CategoryEntityStatus = typeof CategoryEntityStatus[keyof typeof CategoryEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CategoryEntityStatus = {
  Active: 'Active',
  InActive: 'InActive',
} as const;

export interface CategoryEntity {
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  description?: string | null;
  hasFinalConclusion: boolean;
  id?: string;
  isDataList: boolean;
  name: string;
  nameUnAccent?: string;
  status: CategoryEntityStatus;
  type: CategoryEntityType;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyCategoryEntityResponseDto {
  count: number;
  data: CategoryEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type UserEntityType = typeof UserEntityType[keyof typeof UserEntityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEntityType = {
  External: 'External',
  Internal: 'Internal',
} as const;

export interface ClientUserEntity {
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  customerId?: string;
  deletedAt?: string;
  description?: string | null;
  email?: string;
  id?: string;
  name?: string;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
  user?: UserEntity;
  userId: string;
}

export interface GetManyClientUserEntityResponseDto {
  count: number;
  data: ClientUserEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export type ClientEntityStatus = typeof ClientEntityStatus[keyof typeof ClientEntityStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientEntityStatus = {
  Active: 'Active',
  InActive: 'InActive',
} as const;

export interface ClientEntity {
  clientStatus?: string | null;
  code: string;
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  email?: string | null;
  groupCode?: string | null;
  groupName?: string | null;
  id?: string;
  internalId?: string | null;
  legalName?: string | null;
  name: string;
  nameUnAccent?: string;
  status: ClientEntityStatus;
  taxNumber?: string | null;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface UserEntity {
  client?: ClientEntity;
  clientId?: string | null;
  clientUsers?: ClientUserEntity[];
  createdAt?: string;
  createdBy?: UserEntity;
  createdById?: string;
  deletedAt?: string;
  email: string;
  firstName?: string;
  fullName?: string;
  fullNameUnAccent?: string;
  id?: string;
  isSuperAdmin: boolean;
  lastName?: string;
  oid?: string;
  type: UserEntityType;
  updatedAt?: string;
  updatedBy?: UserEntity;
  updatedById?: string;
}

export interface GetManyClientEntityResponseDto {
  count: number;
  data: ClientEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface GetManyUserEntityResponseDto {
  count: number;
  data: UserEntity[];
  page: number;
  pageCount: number;
  total: number;
}

export interface LoginTSMInput {
  token: string;
}





export const appControllerLoginTSM = (
    loginTSMInput: LoginTSMInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/login-tsm`,
      loginTSMInput,options
    );
  }



export const getAppControllerLoginTSMMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof appControllerLoginTSM>>, {data: LoginTSMInput}> = (props) => {
          const {data} = props ?? {};

          return  appControllerLoginTSM(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type AppControllerLoginTSMMutationResult = NonNullable<Awaited<ReturnType<typeof appControllerLoginTSM>>>
    export type AppControllerLoginTSMMutationBody = LoginTSMInput
    export type AppControllerLoginTSMMutationError = AxiosError<unknown>

    export const useAppControllerLoginTSM = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof appControllerLoginTSM>>, TError,{data: LoginTSMInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getAppControllerLoginTSMMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const appControllerGetUserPermissions = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/user-permissions`,options
    );
  }


export const getAppControllerGetUserPermissionsQueryKey = () => {
    return [`/user-permissions`] as const;
    }

    
export const getAppControllerGetUserPermissionsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetUserPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetUserPermissions>>> = ({ signal }) => appControllerGetUserPermissions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerGetUserPermissionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetUserPermissions>>>
export type AppControllerGetUserPermissionsInfiniteQueryError = AxiosError<unknown>

export const useAppControllerGetUserPermissionsInfinite = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppControllerGetUserPermissionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppControllerGetUserPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetUserPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetUserPermissions>>> = ({ signal }) => appControllerGetUserPermissions({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerGetUserPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetUserPermissions>>>
export type AppControllerGetUserPermissionsQueryError = AxiosError<unknown>

export const useAppControllerGetUserPermissions = <TData = Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerGetUserPermissions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppControllerGetUserPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const appControllerMe = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserEntity>> => {
    
    return axios.get(
      `/me`,options
    );
  }


export const getAppControllerMeQueryKey = () => {
    return [`/me`] as const;
    }

    
export const getAppControllerMeInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof appControllerMe>>, TError = AxiosError<unknown>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerMe>>> = ({ signal }) => appControllerMe({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerMeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerMe>>>
export type AppControllerMeInfiniteQueryError = AxiosError<unknown>

export const useAppControllerMeInfinite = <TData = Awaited<ReturnType<typeof appControllerMe>>, TError = AxiosError<unknown>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppControllerMeInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAppControllerMeQueryOptions = <TData = Awaited<ReturnType<typeof appControllerMe>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerMe>>> = ({ signal }) => appControllerMe({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData> & { queryKey: QueryKey }
}

export type AppControllerMeQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerMe>>>
export type AppControllerMeQueryError = AxiosError<unknown>

export const useAppControllerMe = <TData = Awaited<ReturnType<typeof appControllerMe>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof appControllerMe>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppControllerMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single CategoryEntity
 */
export const createOneBaseCategoryControllerCategoryEntity = (
    createCategoryInput: CreateCategoryInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CategoryEntity>> => {
    
    return axios.post(
      `/category`,
      createCategoryInput,options
    );
  }



export const getCreateOneBaseCategoryControllerCategoryEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseCategoryControllerCategoryEntity>>, TError,{data: CreateCategoryInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseCategoryControllerCategoryEntity>>, TError,{data: CreateCategoryInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseCategoryControllerCategoryEntity>>, {data: CreateCategoryInput}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseCategoryControllerCategoryEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseCategoryControllerCategoryEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseCategoryControllerCategoryEntity>>>
    export type CreateOneBaseCategoryControllerCategoryEntityMutationBody = CreateCategoryInput
    export type CreateOneBaseCategoryControllerCategoryEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single CategoryEntity
 */
export const useCreateOneBaseCategoryControllerCategoryEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseCategoryControllerCategoryEntity>>, TError,{data: CreateCategoryInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseCategoryControllerCategoryEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple CategoryEntities
 */
export const getManyBaseCategoryControllerCategoryEntity = (
    params?: GetManyBaseCategoryControllerCategoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyCategoryEntityResponseDto>> => {
    
    return axios.get(
      `/category`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseCategoryControllerCategoryEntityQueryKey = (params?: GetManyBaseCategoryControllerCategoryEntityParams,) => {
    return [`/category`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseCategoryControllerCategoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseCategoryControllerCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseCategoryControllerCategoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>> = ({ signal }) => getManyBaseCategoryControllerCategoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseCategoryControllerCategoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>>
export type GetManyBaseCategoryControllerCategoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple CategoryEntities
 */
export const useGetManyBaseCategoryControllerCategoryEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseCategoryControllerCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseCategoryControllerCategoryEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseCategoryControllerCategoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseCategoryControllerCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseCategoryControllerCategoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>> = ({ signal }) => getManyBaseCategoryControllerCategoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseCategoryControllerCategoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>>
export type GetManyBaseCategoryControllerCategoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple CategoryEntities
 */
export const useGetManyBaseCategoryControllerCategoryEntity = <TData = Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseCategoryControllerCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseCategoryControllerCategoryEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single CategoryEntity
 */
export const updateOneBaseCategoryControllerCategoryEntity = (
    id: string,
    createCategoryInput: CreateCategoryInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CategoryEntity>> => {
    
    return axios.patch(
      `/category/${id}`,
      createCategoryInput,options
    );
  }



export const getUpdateOneBaseCategoryControllerCategoryEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseCategoryControllerCategoryEntity>>, TError,{id: string;data: CreateCategoryInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseCategoryControllerCategoryEntity>>, TError,{id: string;data: CreateCategoryInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseCategoryControllerCategoryEntity>>, {id: string;data: CreateCategoryInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseCategoryControllerCategoryEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseCategoryControllerCategoryEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseCategoryControllerCategoryEntity>>>
    export type UpdateOneBaseCategoryControllerCategoryEntityMutationBody = CreateCategoryInput
    export type UpdateOneBaseCategoryControllerCategoryEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single CategoryEntity
 */
export const useUpdateOneBaseCategoryControllerCategoryEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseCategoryControllerCategoryEntity>>, TError,{id: string;data: CreateCategoryInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseCategoryControllerCategoryEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single CategoryEntity
 */
export const getOneBaseCategoryControllerCategoryEntity = (
    id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CategoryEntity>> => {
    
    return axios.get(
      `/category/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseCategoryControllerCategoryEntityQueryKey = (id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams,) => {
    return [`/category/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseCategoryControllerCategoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseCategoryControllerCategoryEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>> = ({ signal }) => getOneBaseCategoryControllerCategoryEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseCategoryControllerCategoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>>
export type GetOneBaseCategoryControllerCategoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single CategoryEntity
 */
export const useGetOneBaseCategoryControllerCategoryEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseCategoryControllerCategoryEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseCategoryControllerCategoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseCategoryControllerCategoryEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>> = ({ signal }) => getOneBaseCategoryControllerCategoryEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseCategoryControllerCategoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>>
export type GetOneBaseCategoryControllerCategoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single CategoryEntity
 */
export const useGetOneBaseCategoryControllerCategoryEntity = <TData = Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseCategoryControllerCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseCategoryControllerCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseCategoryControllerCategoryEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve a single ChecklistEntity
 */
export const getOneBaseChecklistControllerChecklistEntity = (
    id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChecklistCategoryOutput[]>> => {
    
    return axios.get(
      `/checklist/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseChecklistControllerChecklistEntityQueryKey = (id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams,) => {
    return [`/checklist/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseChecklistControllerChecklistEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseChecklistControllerChecklistEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>> = ({ signal }) => getOneBaseChecklistControllerChecklistEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseChecklistControllerChecklistEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>>
export type GetOneBaseChecklistControllerChecklistEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ChecklistEntity
 */
export const useGetOneBaseChecklistControllerChecklistEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseChecklistControllerChecklistEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseChecklistControllerChecklistEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseChecklistControllerChecklistEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>> = ({ signal }) => getOneBaseChecklistControllerChecklistEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseChecklistControllerChecklistEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>>
export type GetOneBaseChecklistControllerChecklistEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ChecklistEntity
 */
export const useGetOneBaseChecklistControllerChecklistEntity = <TData = Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseChecklistControllerChecklistEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistControllerChecklistEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseChecklistControllerChecklistEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const checklistControllerCreateReport = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.post(
      `/checklist/create-report/${id}`,undefined,options
    );
  }



export const getChecklistControllerCreateReportMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checklistControllerCreateReport>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof checklistControllerCreateReport>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checklistControllerCreateReport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  checklistControllerCreateReport(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ChecklistControllerCreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof checklistControllerCreateReport>>>
    
    export type ChecklistControllerCreateReportMutationError = AxiosError<unknown>

    export const useChecklistControllerCreateReport = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checklistControllerCreateReport>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getChecklistControllerCreateReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const checklistControllerGetChecklistFile = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/checklist/download-report/${id}`,options
    );
  }


export const getChecklistControllerGetChecklistFileQueryKey = (id: string,) => {
    return [`/checklist/download-report/${id}`] as const;
    }

    
export const getChecklistControllerGetChecklistFileInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChecklistControllerGetChecklistFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>> = ({ signal }) => checklistControllerGetChecklistFile(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ChecklistControllerGetChecklistFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>>
export type ChecklistControllerGetChecklistFileInfiniteQueryError = AxiosError<unknown>

export const useChecklistControllerGetChecklistFileInfinite = <TData = Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getChecklistControllerGetChecklistFileInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getChecklistControllerGetChecklistFileQueryOptions = <TData = Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChecklistControllerGetChecklistFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>> = ({ signal }) => checklistControllerGetChecklistFile(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ChecklistControllerGetChecklistFileQueryResult = NonNullable<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>>
export type ChecklistControllerGetChecklistFileQueryError = AxiosError<unknown>

export const useChecklistControllerGetChecklistFile = <TData = Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checklistControllerGetChecklistFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getChecklistControllerGetChecklistFileQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const multiChecklistControllerGetChecklistFiles = (
    params?: MultiChecklistControllerGetChecklistFilesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/multi-checklist/download-reports`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getMultiChecklistControllerGetChecklistFilesQueryKey = (params?: MultiChecklistControllerGetChecklistFilesParams,) => {
    return [`/multi-checklist/download-reports`, ...(params ? [params]: [])] as const;
    }

    
export const getMultiChecklistControllerGetChecklistFilesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError = AxiosError<unknown>>(params?: MultiChecklistControllerGetChecklistFilesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMultiChecklistControllerGetChecklistFilesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>> = ({ signal }) => multiChecklistControllerGetChecklistFiles(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type MultiChecklistControllerGetChecklistFilesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>>
export type MultiChecklistControllerGetChecklistFilesInfiniteQueryError = AxiosError<unknown>

export const useMultiChecklistControllerGetChecklistFilesInfinite = <TData = Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError = AxiosError<unknown>>(
 params?: MultiChecklistControllerGetChecklistFilesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMultiChecklistControllerGetChecklistFilesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMultiChecklistControllerGetChecklistFilesQueryOptions = <TData = Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError = AxiosError<unknown>>(params?: MultiChecklistControllerGetChecklistFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMultiChecklistControllerGetChecklistFilesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>> = ({ signal }) => multiChecklistControllerGetChecklistFiles(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type MultiChecklistControllerGetChecklistFilesQueryResult = NonNullable<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>>
export type MultiChecklistControllerGetChecklistFilesQueryError = AxiosError<unknown>

export const useMultiChecklistControllerGetChecklistFiles = <TData = Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError = AxiosError<unknown>>(
 params?: MultiChecklistControllerGetChecklistFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof multiChecklistControllerGetChecklistFiles>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMultiChecklistControllerGetChecklistFilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upload a file
 */
export const fileStorageControllerUploadFile = (
    fileUploadDTO: FileUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
formData.append('file', fileUploadDTO.file)

    
    return axios.post(
      `/upload-file`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFileMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, {data: FileUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFile(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>>
    export type FileStorageControllerUploadFileMutationBody = FileUploadDTO
    export type FileStorageControllerUploadFileMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFile = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFile>>, TError,{data: FileUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Upload multi files
 */
export const fileStorageControllerUploadFiles = (
    filesUploadDTO: FilesUploadDTO, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
filesUploadDTO.files.forEach(value => formData.append('files', value));

    
    return axios.post(
      `/upload-files`,
      formData,options
    );
  }



export const getFileStorageControllerUploadFilesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, {data: FilesUploadDTO}> = (props) => {
          const {data} = props ?? {};

          return  fileStorageControllerUploadFiles(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type FileStorageControllerUploadFilesMutationResult = NonNullable<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>>
    export type FileStorageControllerUploadFilesMutationBody = FilesUploadDTO
    export type FileStorageControllerUploadFilesMutationError = AxiosError<unknown>

    export const useFileStorageControllerUploadFiles = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileStorageControllerUploadFiles>>, TError,{data: FilesUploadDTO}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getFileStorageControllerUploadFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update a single ChecklistCategoryEntity
 */
export const updateOneBaseChecklistCategoryControllerChecklistCategoryEntity = (
    id: string,
    checklistCategoryInput: ChecklistCategoryInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChecklistCategoryEntity>> => {
    
    return axios.patch(
      `/checklist-category/${id}`,
      checklistCategoryInput,options
    );
  }



export const getUpdateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{id: string;data: ChecklistCategoryInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{id: string;data: ChecklistCategoryInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, {id: string;data: ChecklistCategoryInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseChecklistCategoryControllerChecklistCategoryEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseChecklistCategoryControllerChecklistCategoryEntity>>>
    export type UpdateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationBody = ChecklistCategoryInput
    export type UpdateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single ChecklistCategoryEntity
 */
export const useUpdateOneBaseChecklistCategoryControllerChecklistCategoryEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{id: string;data: ChecklistCategoryInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single ChecklistCategoryEntity
 */
export const getOneBaseChecklistCategoryControllerChecklistCategoryEntity = (
    id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChecklistCategoryEntity>> => {
    
    return axios.get(
      `/checklist-category/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey = (id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams,) => {
    return [`/checklist-category/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>> = ({ signal }) => getOneBaseChecklistCategoryControllerChecklistCategoryEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>>
export type GetOneBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ChecklistCategoryEntity
 */
export const useGetOneBaseChecklistCategoryControllerChecklistCategoryEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>> = ({ signal }) => getOneBaseChecklistCategoryControllerChecklistCategoryEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>>
export type GetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ChecklistCategoryEntity
 */
export const useGetOneBaseChecklistCategoryControllerChecklistCategoryEntity = <TData = Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseChecklistCategoryControllerChecklistCategoryEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple ChecklistCategoryEntities
 */
export const getManyBaseChecklistCategoryControllerChecklistCategoryEntity = (
    params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyChecklistCategoryEntityResponseDto>> => {
    
    return axios.get(
      `/checklist-category`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey = (params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams,) => {
    return [`/checklist-category`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>> = ({ signal }) => getManyBaseChecklistCategoryControllerChecklistCategoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>>
export type GetManyBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple ChecklistCategoryEntities
 */
export const useGetManyBaseChecklistCategoryControllerChecklistCategoryEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>> = ({ signal }) => getManyBaseChecklistCategoryControllerChecklistCategoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>>
export type GetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple ChecklistCategoryEntities
 */
export const useGetManyBaseChecklistCategoryControllerChecklistCategoryEntity = <TData = Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseChecklistCategoryControllerChecklistCategoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseChecklistCategoryControllerChecklistCategoryEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single ChecklistCategoryEntity
 */
export const createOneBaseChecklistCategoryControllerChecklistCategoryEntity = (
    checklistCategoryEntity: ChecklistCategoryEntity, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChecklistCategoryEntity>> => {
    
    return axios.post(
      `/checklist-category`,
      checklistCategoryEntity,options
    );
  }



export const getCreateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{data: ChecklistCategoryEntity}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{data: ChecklistCategoryEntity}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, {data: ChecklistCategoryEntity}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseChecklistCategoryControllerChecklistCategoryEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseChecklistCategoryControllerChecklistCategoryEntity>>>
    export type CreateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationBody = ChecklistCategoryEntity
    export type CreateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single ChecklistCategoryEntity
 */
export const useCreateOneBaseChecklistCategoryControllerChecklistCategoryEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseChecklistCategoryControllerChecklistCategoryEntity>>, TError,{data: ChecklistCategoryEntity}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseChecklistCategoryControllerChecklistCategoryEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const clientControllerSynchData = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/client/synch-data`,undefined,options
    );
  }



export const getClientControllerSynchDataMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerSynchData>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof clientControllerSynchData>>, TError,void, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerSynchData>>, void> = () => {
          

          return  clientControllerSynchData(axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ClientControllerSynchDataMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerSynchData>>>
    
    export type ClientControllerSynchDataMutationError = AxiosError<unknown>

    export const useClientControllerSynchData = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerSynchData>>, TError,void, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getClientControllerSynchDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple ClientEntities
 */
export const getManyBaseClientControllerClientEntity = (
    params?: GetManyBaseClientControllerClientEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyClientEntityResponseDto>> => {
    
    return axios.get(
      `/client`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseClientControllerClientEntityQueryKey = (params?: GetManyBaseClientControllerClientEntityParams,) => {
    return [`/client`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseClientControllerClientEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseClientControllerClientEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseClientControllerClientEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>> = ({ signal }) => getManyBaseClientControllerClientEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseClientControllerClientEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>>
export type GetManyBaseClientControllerClientEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple ClientEntities
 */
export const useGetManyBaseClientControllerClientEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseClientControllerClientEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseClientControllerClientEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseClientControllerClientEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseClientControllerClientEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseClientControllerClientEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>> = ({ signal }) => getManyBaseClientControllerClientEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseClientControllerClientEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>>
export type GetManyBaseClientControllerClientEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple ClientEntities
 */
export const useGetManyBaseClientControllerClientEntity = <TData = Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseClientControllerClientEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseClientControllerClientEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clientControllerDeleteConfigClient = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    return axios.delete(
      `/client/config-client/${id}`,options
    );
  }



export const getClientControllerDeleteConfigClientMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerDeleteConfigClient>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof clientControllerDeleteConfigClient>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerDeleteConfigClient>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  clientControllerDeleteConfigClient(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ClientControllerDeleteConfigClientMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerDeleteConfigClient>>>
    
    export type ClientControllerDeleteConfigClientMutationError = AxiosError<unknown>

    export const useClientControllerDeleteConfigClient = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerDeleteConfigClient>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getClientControllerDeleteConfigClientMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single ClientEntity
 */
export const getOneBaseClientControllerClientEntity = (
    id: string,
    params?: GetOneBaseClientControllerClientEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ClientEntity>> => {
    
    return axios.get(
      `/client/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseClientControllerClientEntityQueryKey = (id: string,
    params?: GetOneBaseClientControllerClientEntityParams,) => {
    return [`/client/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseClientControllerClientEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseClientControllerClientEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseClientControllerClientEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>> = ({ signal }) => getOneBaseClientControllerClientEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseClientControllerClientEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>>
export type GetOneBaseClientControllerClientEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ClientEntity
 */
export const useGetOneBaseClientControllerClientEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseClientControllerClientEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseClientControllerClientEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseClientControllerClientEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseClientControllerClientEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseClientControllerClientEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>> = ({ signal }) => getOneBaseClientControllerClientEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseClientControllerClientEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>>
export type GetOneBaseClientControllerClientEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ClientEntity
 */
export const useGetOneBaseClientControllerClientEntity = <TData = Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseClientControllerClientEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientControllerClientEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseClientControllerClientEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clientUserControllerGetClientsOfUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/client-user`,options
    );
  }


export const getClientUserControllerGetClientsOfUserQueryKey = () => {
    return [`/client-user`] as const;
    }

    
export const getClientUserControllerGetClientsOfUserInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError = AxiosError<unknown>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientUserControllerGetClientsOfUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>> = ({ signal }) => clientUserControllerGetClientsOfUser({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData> & { queryKey: QueryKey }
}

export type ClientUserControllerGetClientsOfUserInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>>
export type ClientUserControllerGetClientsOfUserInfiniteQueryError = AxiosError<unknown>

export const useClientUserControllerGetClientsOfUserInfinite = <TData = Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClientUserControllerGetClientsOfUserInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getClientUserControllerGetClientsOfUserQueryOptions = <TData = Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientUserControllerGetClientsOfUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>> = ({ signal }) => clientUserControllerGetClientsOfUser({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData> & { queryKey: QueryKey }
}

export type ClientUserControllerGetClientsOfUserQueryResult = NonNullable<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>>
export type ClientUserControllerGetClientsOfUserQueryError = AxiosError<unknown>

export const useClientUserControllerGetClientsOfUser = <TData = Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientUserControllerGetClientsOfUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getClientUserControllerGetClientsOfUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const clientUserControllerConfigCustomerUser = (
    createCustomerUserInput: CreateCustomerUserInput[],
    params: ClientUserControllerConfigCustomerUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/client-user/config-user`,
      createCustomerUserInput,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getClientUserControllerConfigCustomerUserMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientUserControllerConfigCustomerUser>>, TError,{data: CreateCustomerUserInput[];params: ClientUserControllerConfigCustomerUserParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof clientUserControllerConfigCustomerUser>>, TError,{data: CreateCustomerUserInput[];params: ClientUserControllerConfigCustomerUserParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientUserControllerConfigCustomerUser>>, {data: CreateCustomerUserInput[];params: ClientUserControllerConfigCustomerUserParams}> = (props) => {
          const {data,params} = props ?? {};

          return  clientUserControllerConfigCustomerUser(data,params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ClientUserControllerConfigCustomerUserMutationResult = NonNullable<Awaited<ReturnType<typeof clientUserControllerConfigCustomerUser>>>
    export type ClientUserControllerConfigCustomerUserMutationBody = CreateCustomerUserInput[]
    export type ClientUserControllerConfigCustomerUserMutationError = AxiosError<unknown>

    export const useClientUserControllerConfigCustomerUser = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientUserControllerConfigCustomerUser>>, TError,{data: CreateCustomerUserInput[];params: ClientUserControllerConfigCustomerUserParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getClientUserControllerConfigCustomerUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single ClientUserEntity
 */
export const getOneBaseClientUserControllerClientUserEntity = (
    id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ClientUserEntity>> => {
    
    return axios.get(
      `/client-user/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseClientUserControllerClientUserEntityQueryKey = (id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams,) => {
    return [`/client-user/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseClientUserControllerClientUserEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseClientUserControllerClientUserEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>> = ({ signal }) => getOneBaseClientUserControllerClientUserEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseClientUserControllerClientUserEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>>
export type GetOneBaseClientUserControllerClientUserEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ClientUserEntity
 */
export const useGetOneBaseClientUserControllerClientUserEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseClientUserControllerClientUserEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseClientUserControllerClientUserEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseClientUserControllerClientUserEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>> = ({ signal }) => getOneBaseClientUserControllerClientUserEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseClientUserControllerClientUserEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>>
export type GetOneBaseClientUserControllerClientUserEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single ClientUserEntity
 */
export const useGetOneBaseClientUserControllerClientUserEntity = <TData = Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseClientUserControllerClientUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseClientUserControllerClientUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseClientUserControllerClientUserEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single FieldEntity
 */
export const createOneBaseFieldControllerFieldEntity = (
    createFieldInput: CreateFieldInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FieldEntity>> => {
    
    return axios.post(
      `/field`,
      createFieldInput,options
    );
  }



export const getCreateOneBaseFieldControllerFieldEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseFieldControllerFieldEntity>>, TError,{data: CreateFieldInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseFieldControllerFieldEntity>>, TError,{data: CreateFieldInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseFieldControllerFieldEntity>>, {data: CreateFieldInput}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseFieldControllerFieldEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseFieldControllerFieldEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseFieldControllerFieldEntity>>>
    export type CreateOneBaseFieldControllerFieldEntityMutationBody = CreateFieldInput
    export type CreateOneBaseFieldControllerFieldEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single FieldEntity
 */
export const useCreateOneBaseFieldControllerFieldEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseFieldControllerFieldEntity>>, TError,{data: CreateFieldInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseFieldControllerFieldEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple FieldEntities
 */
export const getManyBaseFieldControllerFieldEntity = (
    params?: GetManyBaseFieldControllerFieldEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyFieldEntityResponseDto>> => {
    
    return axios.get(
      `/field`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseFieldControllerFieldEntityQueryKey = (params?: GetManyBaseFieldControllerFieldEntityParams,) => {
    return [`/field`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseFieldControllerFieldEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseFieldControllerFieldEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseFieldControllerFieldEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>> = ({ signal }) => getManyBaseFieldControllerFieldEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseFieldControllerFieldEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>>
export type GetManyBaseFieldControllerFieldEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple FieldEntities
 */
export const useGetManyBaseFieldControllerFieldEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseFieldControllerFieldEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseFieldControllerFieldEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseFieldControllerFieldEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseFieldControllerFieldEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseFieldControllerFieldEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>> = ({ signal }) => getManyBaseFieldControllerFieldEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseFieldControllerFieldEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>>
export type GetManyBaseFieldControllerFieldEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple FieldEntities
 */
export const useGetManyBaseFieldControllerFieldEntity = <TData = Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseFieldControllerFieldEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseFieldControllerFieldEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single FieldEntity
 */
export const updateOneBaseFieldControllerFieldEntity = (
    id: string,
    createFieldInput: CreateFieldInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FieldEntity>> => {
    
    return axios.patch(
      `/field/${id}`,
      createFieldInput,options
    );
  }



export const getUpdateOneBaseFieldControllerFieldEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseFieldControllerFieldEntity>>, TError,{id: string;data: CreateFieldInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseFieldControllerFieldEntity>>, TError,{id: string;data: CreateFieldInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseFieldControllerFieldEntity>>, {id: string;data: CreateFieldInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseFieldControllerFieldEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseFieldControllerFieldEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseFieldControllerFieldEntity>>>
    export type UpdateOneBaseFieldControllerFieldEntityMutationBody = CreateFieldInput
    export type UpdateOneBaseFieldControllerFieldEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single FieldEntity
 */
export const useUpdateOneBaseFieldControllerFieldEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseFieldControllerFieldEntity>>, TError,{id: string;data: CreateFieldInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseFieldControllerFieldEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single FieldEntity
 */
export const getOneBaseFieldControllerFieldEntity = (
    id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FieldEntity>> => {
    
    return axios.get(
      `/field/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseFieldControllerFieldEntityQueryKey = (id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams,) => {
    return [`/field/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseFieldControllerFieldEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseFieldControllerFieldEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>> = ({ signal }) => getOneBaseFieldControllerFieldEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseFieldControllerFieldEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>>
export type GetOneBaseFieldControllerFieldEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single FieldEntity
 */
export const useGetOneBaseFieldControllerFieldEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseFieldControllerFieldEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseFieldControllerFieldEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseFieldControllerFieldEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>> = ({ signal }) => getOneBaseFieldControllerFieldEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseFieldControllerFieldEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>>
export type GetOneBaseFieldControllerFieldEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single FieldEntity
 */
export const useGetOneBaseFieldControllerFieldEntity = <TData = Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseFieldControllerFieldEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseFieldControllerFieldEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseFieldControllerFieldEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve a single LogEntity
 */
export const getOneBaseLogControllerLogEntity = (
    id: string,
    params?: GetOneBaseLogControllerLogEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LogEntity>> => {
    
    return axios.get(
      `/log/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseLogControllerLogEntityQueryKey = (id: string,
    params?: GetOneBaseLogControllerLogEntityParams,) => {
    return [`/log/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseLogControllerLogEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseLogControllerLogEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseLogControllerLogEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>> = ({ signal }) => getOneBaseLogControllerLogEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseLogControllerLogEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>>
export type GetOneBaseLogControllerLogEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single LogEntity
 */
export const useGetOneBaseLogControllerLogEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseLogControllerLogEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseLogControllerLogEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseLogControllerLogEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseLogControllerLogEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseLogControllerLogEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>> = ({ signal }) => getOneBaseLogControllerLogEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseLogControllerLogEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>>
export type GetOneBaseLogControllerLogEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single LogEntity
 */
export const useGetOneBaseLogControllerLogEntity = <TData = Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseLogControllerLogEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseLogControllerLogEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple LogEntities
 */
export const getManyBaseLogControllerLogEntity = (
    params?: GetManyBaseLogControllerLogEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyLogEntityResponseDto>> => {
    
    return axios.get(
      `/log`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseLogControllerLogEntityQueryKey = (params?: GetManyBaseLogControllerLogEntityParams,) => {
    return [`/log`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseLogControllerLogEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseLogControllerLogEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseLogControllerLogEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>> = ({ signal }) => getManyBaseLogControllerLogEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseLogControllerLogEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>>
export type GetManyBaseLogControllerLogEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple LogEntities
 */
export const useGetManyBaseLogControllerLogEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseLogControllerLogEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseLogControllerLogEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseLogControllerLogEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseLogControllerLogEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseLogControllerLogEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>> = ({ signal }) => getManyBaseLogControllerLogEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseLogControllerLogEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>>
export type GetManyBaseLogControllerLogEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple LogEntities
 */
export const useGetManyBaseLogControllerLogEntity = <TData = Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseLogControllerLogEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseLogControllerLogEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseLogControllerLogEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single RequestCandidateEntity
 */
export const createOneBaseRequestCandidateControllerRequestCandidateEntity = (
    requestCandidateEntity: RequestCandidateEntity, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestCandidateEntity>> => {
    
    return axios.post(
      `/request-candidate`,
      requestCandidateEntity,options
    );
  }



export const getCreateOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{data: RequestCandidateEntity}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{data: RequestCandidateEntity}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseRequestCandidateControllerRequestCandidateEntity>>, {data: RequestCandidateEntity}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseRequestCandidateControllerRequestCandidateEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseRequestCandidateControllerRequestCandidateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseRequestCandidateControllerRequestCandidateEntity>>>
    export type CreateOneBaseRequestCandidateControllerRequestCandidateEntityMutationBody = RequestCandidateEntity
    export type CreateOneBaseRequestCandidateControllerRequestCandidateEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single RequestCandidateEntity
 */
export const useCreateOneBaseRequestCandidateControllerRequestCandidateEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{data: RequestCandidateEntity}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple RequestCandidateEntities
 */
export const getManyBaseRequestCandidateControllerRequestCandidateEntity = (
    params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyRequestCandidateEntityResponseDto>> => {
    
    return axios.get(
      `/request-candidate`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseRequestCandidateControllerRequestCandidateEntityQueryKey = (params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams,) => {
    return [`/request-candidate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestCandidateControllerRequestCandidateEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>> = ({ signal }) => getManyBaseRequestCandidateControllerRequestCandidateEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>>
export type GetManyBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestCandidateEntities
 */
export const useGetManyBaseRequestCandidateControllerRequestCandidateEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseRequestCandidateControllerRequestCandidateEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestCandidateControllerRequestCandidateEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>> = ({ signal }) => getManyBaseRequestCandidateControllerRequestCandidateEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestCandidateControllerRequestCandidateEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>>
export type GetManyBaseRequestCandidateControllerRequestCandidateEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestCandidateEntities
 */
export const useGetManyBaseRequestCandidateControllerRequestCandidateEntity = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestCandidateControllerRequestCandidateEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single RequestCandidateEntity
 */
export const updateOneBaseRequestCandidateControllerRequestCandidateEntity = (
    id: string,
    requestCandidateEntity: RequestCandidateEntity, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestCandidateEntity>> => {
    
    return axios.patch(
      `/request-candidate/${id}`,
      requestCandidateEntity,options
    );
  }



export const getUpdateOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string;data: RequestCandidateEntity}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string;data: RequestCandidateEntity}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseRequestCandidateControllerRequestCandidateEntity>>, {id: string;data: RequestCandidateEntity}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseRequestCandidateControllerRequestCandidateEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseRequestCandidateControllerRequestCandidateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseRequestCandidateControllerRequestCandidateEntity>>>
    export type UpdateOneBaseRequestCandidateControllerRequestCandidateEntityMutationBody = RequestCandidateEntity
    export type UpdateOneBaseRequestCandidateControllerRequestCandidateEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single RequestCandidateEntity
 */
export const useUpdateOneBaseRequestCandidateControllerRequestCandidateEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string;data: RequestCandidateEntity}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete a single RequestCandidateEntity
 */
export const deleteOneBaseRequestCandidateControllerRequestCandidateEntity = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/request-candidate/${id}`,options
    );
  }



export const getDeleteOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseRequestCandidateControllerRequestCandidateEntity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseRequestCandidateControllerRequestCandidateEntity(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseRequestCandidateControllerRequestCandidateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseRequestCandidateControllerRequestCandidateEntity>>>
    
    export type DeleteOneBaseRequestCandidateControllerRequestCandidateEntityMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single RequestCandidateEntity
 */
export const useDeleteOneBaseRequestCandidateControllerRequestCandidateEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseRequestCandidateControllerRequestCandidateEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single RequestCandidateEntity
 */
export const getOneBaseRequestCandidateControllerRequestCandidateEntity = (
    id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestCandidateEntity>> => {
    
    return axios.get(
      `/request-candidate/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseRequestCandidateControllerRequestCandidateEntityQueryKey = (id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams,) => {
    return [`/request-candidate/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseRequestCandidateControllerRequestCandidateEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>> = ({ signal }) => getOneBaseRequestCandidateControllerRequestCandidateEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>>
export type GetOneBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single RequestCandidateEntity
 */
export const useGetOneBaseRequestCandidateControllerRequestCandidateEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseRequestCandidateControllerRequestCandidateEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseRequestCandidateControllerRequestCandidateEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseRequestCandidateControllerRequestCandidateEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>> = ({ signal }) => getOneBaseRequestCandidateControllerRequestCandidateEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseRequestCandidateControllerRequestCandidateEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>>
export type GetOneBaseRequestCandidateControllerRequestCandidateEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single RequestCandidateEntity
 */
export const useGetOneBaseRequestCandidateControllerRequestCandidateEntity = <TData = Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseRequestCandidateControllerRequestCandidateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestCandidateControllerRequestCandidateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseRequestCandidateControllerRequestCandidateEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const requestCandidateControllerGetRequestCandidateFile = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/request-candidate/download/${id}`,options
    );
  }


export const getRequestCandidateControllerGetRequestCandidateFileQueryKey = (id: string,) => {
    return [`/request-candidate/download/${id}`] as const;
    }

    
export const getRequestCandidateControllerGetRequestCandidateFileInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestCandidateControllerGetRequestCandidateFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>> = ({ signal }) => requestCandidateControllerGetRequestCandidateFile(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData> & { queryKey: QueryKey }
}

export type RequestCandidateControllerGetRequestCandidateFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>>
export type RequestCandidateControllerGetRequestCandidateFileInfiniteQueryError = AxiosError<unknown>

export const useRequestCandidateControllerGetRequestCandidateFileInfinite = <TData = Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getRequestCandidateControllerGetRequestCandidateFileInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRequestCandidateControllerGetRequestCandidateFileQueryOptions = <TData = Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRequestCandidateControllerGetRequestCandidateFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>> = ({ signal }) => requestCandidateControllerGetRequestCandidateFile(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData> & { queryKey: QueryKey }
}

export type RequestCandidateControllerGetRequestCandidateFileQueryResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>>
export type RequestCandidateControllerGetRequestCandidateFileQueryError = AxiosError<unknown>

export const useRequestCandidateControllerGetRequestCandidateFile = <TData = Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof requestCandidateControllerGetRequestCandidateFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getRequestCandidateControllerGetRequestCandidateFileQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const requestCandidateControllerSubmitForReview = (
    params: RequestCandidateControllerSubmitForReviewParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/request-candidate/review`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestCandidateControllerSubmitForReviewMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerSubmitForReview>>, TError,{params: RequestCandidateControllerSubmitForReviewParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerSubmitForReview>>, TError,{params: RequestCandidateControllerSubmitForReviewParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCandidateControllerSubmitForReview>>, {params: RequestCandidateControllerSubmitForReviewParams}> = (props) => {
          const {params} = props ?? {};

          return  requestCandidateControllerSubmitForReview(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestCandidateControllerSubmitForReviewMutationResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerSubmitForReview>>>
    
    export type RequestCandidateControllerSubmitForReviewMutationError = AxiosError<unknown>

    export const useRequestCandidateControllerSubmitForReview = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerSubmitForReview>>, TError,{params: RequestCandidateControllerSubmitForReviewParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestCandidateControllerSubmitForReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestCandidateControllerUpdateStatus = (
    id: string,
    params: RequestCandidateControllerUpdateStatusParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.patch(
      `/request-candidate/update-status/${id}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestCandidateControllerUpdateStatusMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerUpdateStatus>>, TError,{id: string;params: RequestCandidateControllerUpdateStatusParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerUpdateStatus>>, TError,{id: string;params: RequestCandidateControllerUpdateStatusParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCandidateControllerUpdateStatus>>, {id: string;params: RequestCandidateControllerUpdateStatusParams}> = (props) => {
          const {id,params} = props ?? {};

          return  requestCandidateControllerUpdateStatus(id,params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestCandidateControllerUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerUpdateStatus>>>
    
    export type RequestCandidateControllerUpdateStatusMutationError = AxiosError<unknown>

    export const useRequestCandidateControllerUpdateStatus = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerUpdateStatus>>, TError,{id: string;params: RequestCandidateControllerUpdateStatusParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestCandidateControllerUpdateStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestCandidateControllerApproveRequestCandidate = (
    params: RequestCandidateControllerApproveRequestCandidateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/request-candidate/approve`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestCandidateControllerApproveRequestCandidateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerApproveRequestCandidate>>, TError,{params: RequestCandidateControllerApproveRequestCandidateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerApproveRequestCandidate>>, TError,{params: RequestCandidateControllerApproveRequestCandidateParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCandidateControllerApproveRequestCandidate>>, {params: RequestCandidateControllerApproveRequestCandidateParams}> = (props) => {
          const {params} = props ?? {};

          return  requestCandidateControllerApproveRequestCandidate(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestCandidateControllerApproveRequestCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerApproveRequestCandidate>>>
    
    export type RequestCandidateControllerApproveRequestCandidateMutationError = AxiosError<unknown>

    export const useRequestCandidateControllerApproveRequestCandidate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerApproveRequestCandidate>>, TError,{params: RequestCandidateControllerApproveRequestCandidateParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestCandidateControllerApproveRequestCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestCandidateControllerRejectRequestCandidate = (
    params: RequestCandidateControllerRejectRequestCandidateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.post(
      `/request-candidate/reject`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestCandidateControllerRejectRequestCandidateMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerRejectRequestCandidate>>, TError,{params: RequestCandidateControllerRejectRequestCandidateParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerRejectRequestCandidate>>, TError,{params: RequestCandidateControllerRejectRequestCandidateParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestCandidateControllerRejectRequestCandidate>>, {params: RequestCandidateControllerRejectRequestCandidateParams}> = (props) => {
          const {params} = props ?? {};

          return  requestCandidateControllerRejectRequestCandidate(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestCandidateControllerRejectRequestCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof requestCandidateControllerRejectRequestCandidate>>>
    
    export type RequestCandidateControllerRejectRequestCandidateMutationError = AxiosError<unknown>

    export const useRequestCandidateControllerRejectRequestCandidate = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestCandidateControllerRejectRequestCandidate>>, TError,{params: RequestCandidateControllerRejectRequestCandidateParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestCandidateControllerRejectRequestCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single RequestEntity
 */
export const createOneBaseRequestControllerRequestEntity = (
    createRequestInput: CreateRequestInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestEntity>> => {
    
    return axios.post(
      `/request`,
      createRequestInput,options
    );
  }



export const getCreateOneBaseRequestControllerRequestEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestControllerRequestEntity>>, TError,{data: CreateRequestInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestControllerRequestEntity>>, TError,{data: CreateRequestInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseRequestControllerRequestEntity>>, {data: CreateRequestInput}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseRequestControllerRequestEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseRequestControllerRequestEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseRequestControllerRequestEntity>>>
    export type CreateOneBaseRequestControllerRequestEntityMutationBody = CreateRequestInput
    export type CreateOneBaseRequestControllerRequestEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single RequestEntity
 */
export const useCreateOneBaseRequestControllerRequestEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseRequestControllerRequestEntity>>, TError,{data: CreateRequestInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseRequestControllerRequestEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple RequestEntities
 */
export const getManyBaseRequestControllerRequestEntity = (
    params?: GetManyBaseRequestControllerRequestEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyRequestEntityResponseDto>> => {
    
    return axios.get(
      `/request`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseRequestControllerRequestEntityQueryKey = (params?: GetManyBaseRequestControllerRequestEntityParams,) => {
    return [`/request`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseRequestControllerRequestEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestControllerRequestEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestControllerRequestEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>> = ({ signal }) => getManyBaseRequestControllerRequestEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestControllerRequestEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>>
export type GetManyBaseRequestControllerRequestEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestEntities
 */
export const useGetManyBaseRequestControllerRequestEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestControllerRequestEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestControllerRequestEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseRequestControllerRequestEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestControllerRequestEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestControllerRequestEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>> = ({ signal }) => getManyBaseRequestControllerRequestEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestControllerRequestEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>>
export type GetManyBaseRequestControllerRequestEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestEntities
 */
export const useGetManyBaseRequestControllerRequestEntity = <TData = Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestControllerRequestEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestControllerRequestEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single RequestEntity
 */
export const updateOneBaseRequestControllerRequestEntity = (
    id: string,
    createRequestInput: CreateRequestInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestEntity>> => {
    
    return axios.patch(
      `/request/${id}`,
      createRequestInput,options
    );
  }



export const getUpdateOneBaseRequestControllerRequestEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestControllerRequestEntity>>, TError,{id: string;data: CreateRequestInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestControllerRequestEntity>>, TError,{id: string;data: CreateRequestInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseRequestControllerRequestEntity>>, {id: string;data: CreateRequestInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseRequestControllerRequestEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseRequestControllerRequestEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseRequestControllerRequestEntity>>>
    export type UpdateOneBaseRequestControllerRequestEntityMutationBody = CreateRequestInput
    export type UpdateOneBaseRequestControllerRequestEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single RequestEntity
 */
export const useUpdateOneBaseRequestControllerRequestEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseRequestControllerRequestEntity>>, TError,{id: string;data: CreateRequestInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseRequestControllerRequestEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single RequestEntity
 */
export const getOneBaseRequestControllerRequestEntity = (
    id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RequestEntity>> => {
    
    return axios.get(
      `/request/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseRequestControllerRequestEntityQueryKey = (id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams,) => {
    return [`/request/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseRequestControllerRequestEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseRequestControllerRequestEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>> = ({ signal }) => getOneBaseRequestControllerRequestEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseRequestControllerRequestEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>>
export type GetOneBaseRequestControllerRequestEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single RequestEntity
 */
export const useGetOneBaseRequestControllerRequestEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseRequestControllerRequestEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseRequestControllerRequestEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseRequestControllerRequestEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>> = ({ signal }) => getOneBaseRequestControllerRequestEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseRequestControllerRequestEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>>
export type GetOneBaseRequestControllerRequestEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single RequestEntity
 */
export const useGetOneBaseRequestControllerRequestEntity = <TData = Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseRequestControllerRequestEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseRequestControllerRequestEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseRequestControllerRequestEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const requestControllerSendRequest = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.patch(
      `/request/send-request/${id}`,undefined,options
    );
  }



export const getRequestControllerSendRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerSendRequest>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestControllerSendRequest>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestControllerSendRequest>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  requestControllerSendRequest(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestControllerSendRequestMutationResult = NonNullable<Awaited<ReturnType<typeof requestControllerSendRequest>>>
    
    export type RequestControllerSendRequestMutationError = AxiosError<unknown>

    export const useRequestControllerSendRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerSendRequest>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestControllerSendRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestControllerApproveRequest = (
    id: string,
    params: RequestControllerApproveRequestParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.patch(
      `/request/approve/${id}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestControllerApproveRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerApproveRequest>>, TError,{id: string;params: RequestControllerApproveRequestParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestControllerApproveRequest>>, TError,{id: string;params: RequestControllerApproveRequestParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestControllerApproveRequest>>, {id: string;params: RequestControllerApproveRequestParams}> = (props) => {
          const {id,params} = props ?? {};

          return  requestControllerApproveRequest(id,params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestControllerApproveRequestMutationResult = NonNullable<Awaited<ReturnType<typeof requestControllerApproveRequest>>>
    
    export type RequestControllerApproveRequestMutationError = AxiosError<unknown>

    export const useRequestControllerApproveRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerApproveRequest>>, TError,{id: string;params: RequestControllerApproveRequestParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestControllerApproveRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestControllerRejectRequest = (
    id: string,
    params: RequestControllerRejectRequestParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.patch(
      `/request/reject/${id}`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestControllerRejectRequestMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerRejectRequest>>, TError,{id: string;params: RequestControllerRejectRequestParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestControllerRejectRequest>>, TError,{id: string;params: RequestControllerRejectRequestParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestControllerRejectRequest>>, {id: string;params: RequestControllerRejectRequestParams}> = (props) => {
          const {id,params} = props ?? {};

          return  requestControllerRejectRequest(id,params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestControllerRejectRequestMutationResult = NonNullable<Awaited<ReturnType<typeof requestControllerRejectRequest>>>
    
    export type RequestControllerRejectRequestMutationError = AxiosError<unknown>

    export const useRequestControllerRejectRequest = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerRejectRequest>>, TError,{id: string;params: RequestControllerRejectRequestParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestControllerRejectRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const requestControllerCheckContractor = (
    params: RequestControllerCheckContractorParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<boolean>> => {
    
    return axios.post(
      `/request/check-contractor`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRequestControllerCheckContractorMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerCheckContractor>>, TError,{params: RequestControllerCheckContractorParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof requestControllerCheckContractor>>, TError,{params: RequestControllerCheckContractorParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestControllerCheckContractor>>, {params: RequestControllerCheckContractorParams}> = (props) => {
          const {params} = props ?? {};

          return  requestControllerCheckContractor(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RequestControllerCheckContractorMutationResult = NonNullable<Awaited<ReturnType<typeof requestControllerCheckContractor>>>
    
    export type RequestControllerCheckContractorMutationError = AxiosError<unknown>

    export const useRequestControllerCheckContractor = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestControllerCheckContractor>>, TError,{params: RequestControllerCheckContractorParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getRequestControllerCheckContractorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a single TemplateEntity
 */
export const createOneBaseTemplateControllerTemplateEntity = (
    createTemplateInput: CreateTemplateInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateEntity>> => {
    
    return axios.post(
      `/template`,
      createTemplateInput,options
    );
  }



export const getCreateOneBaseTemplateControllerTemplateEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateControllerTemplateEntity>>, TError,{data: CreateTemplateInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateControllerTemplateEntity>>, TError,{data: CreateTemplateInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseTemplateControllerTemplateEntity>>, {data: CreateTemplateInput}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseTemplateControllerTemplateEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseTemplateControllerTemplateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseTemplateControllerTemplateEntity>>>
    export type CreateOneBaseTemplateControllerTemplateEntityMutationBody = CreateTemplateInput
    export type CreateOneBaseTemplateControllerTemplateEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single TemplateEntity
 */
export const useCreateOneBaseTemplateControllerTemplateEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateControllerTemplateEntity>>, TError,{data: CreateTemplateInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseTemplateControllerTemplateEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple TemplateEntities
 */
export const getManyBaseTemplateControllerTemplateEntity = (
    params?: GetManyBaseTemplateControllerTemplateEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyTemplateEntityResponseDto>> => {
    
    return axios.get(
      `/template`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseTemplateControllerTemplateEntityQueryKey = (params?: GetManyBaseTemplateControllerTemplateEntityParams,) => {
    return [`/template`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseTemplateControllerTemplateEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseTemplateControllerTemplateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseTemplateControllerTemplateEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>> = ({ signal }) => getManyBaseTemplateControllerTemplateEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseTemplateControllerTemplateEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>>
export type GetManyBaseTemplateControllerTemplateEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple TemplateEntities
 */
export const useGetManyBaseTemplateControllerTemplateEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseTemplateControllerTemplateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseTemplateControllerTemplateEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseTemplateControllerTemplateEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseTemplateControllerTemplateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseTemplateControllerTemplateEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>> = ({ signal }) => getManyBaseTemplateControllerTemplateEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseTemplateControllerTemplateEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>>
export type GetManyBaseTemplateControllerTemplateEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple TemplateEntities
 */
export const useGetManyBaseTemplateControllerTemplateEntity = <TData = Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseTemplateControllerTemplateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseTemplateControllerTemplateEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single TemplateEntity
 */
export const updateOneBaseTemplateControllerTemplateEntity = (
    id: string,
    createTemplateInput: CreateTemplateInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateEntity>> => {
    
    return axios.patch(
      `/template/${id}`,
      createTemplateInput,options
    );
  }



export const getUpdateOneBaseTemplateControllerTemplateEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateControllerTemplateEntity>>, TError,{id: string;data: CreateTemplateInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateControllerTemplateEntity>>, TError,{id: string;data: CreateTemplateInput}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseTemplateControllerTemplateEntity>>, {id: string;data: CreateTemplateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseTemplateControllerTemplateEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseTemplateControllerTemplateEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseTemplateControllerTemplateEntity>>>
    export type UpdateOneBaseTemplateControllerTemplateEntityMutationBody = CreateTemplateInput
    export type UpdateOneBaseTemplateControllerTemplateEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single TemplateEntity
 */
export const useUpdateOneBaseTemplateControllerTemplateEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateControllerTemplateEntity>>, TError,{id: string;data: CreateTemplateInput}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseTemplateControllerTemplateEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single TemplateEntity
 */
export const getOneBaseTemplateControllerTemplateEntity = (
    id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateEntity>> => {
    
    return axios.get(
      `/template/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseTemplateControllerTemplateEntityQueryKey = (id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams,) => {
    return [`/template/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseTemplateControllerTemplateEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseTemplateControllerTemplateEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>> = ({ signal }) => getOneBaseTemplateControllerTemplateEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseTemplateControllerTemplateEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>>
export type GetOneBaseTemplateControllerTemplateEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single TemplateEntity
 */
export const useGetOneBaseTemplateControllerTemplateEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseTemplateControllerTemplateEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseTemplateControllerTemplateEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseTemplateControllerTemplateEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>> = ({ signal }) => getOneBaseTemplateControllerTemplateEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseTemplateControllerTemplateEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>>
export type GetOneBaseTemplateControllerTemplateEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single TemplateEntity
 */
export const useGetOneBaseTemplateControllerTemplateEntity = <TData = Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseTemplateControllerTemplateEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateControllerTemplateEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseTemplateControllerTemplateEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const templateControllerExportTemplate = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.get(
      `/template/export-template/${id}`,options
    );
  }


export const getTemplateControllerExportTemplateQueryKey = (id: string,) => {
    return [`/template/export-template/${id}`] as const;
    }

    
export const getTemplateControllerExportTemplateInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplateControllerExportTemplateQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof templateControllerExportTemplate>>> = ({ signal }) => templateControllerExportTemplate(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type TemplateControllerExportTemplateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof templateControllerExportTemplate>>>
export type TemplateControllerExportTemplateInfiniteQueryError = AxiosError<unknown>

export const useTemplateControllerExportTemplateInfinite = <TData = Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTemplateControllerExportTemplateInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTemplateControllerExportTemplateQueryOptions = <TData = Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError = AxiosError<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplateControllerExportTemplateQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof templateControllerExportTemplate>>> = ({ signal }) => templateControllerExportTemplate(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData> & { queryKey: QueryKey }
}

export type TemplateControllerExportTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof templateControllerExportTemplate>>>
export type TemplateControllerExportTemplateQueryError = AxiosError<unknown>

export const useTemplateControllerExportTemplate = <TData = Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof templateControllerExportTemplate>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getTemplateControllerExportTemplateQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a single TemplateTypeEntity
 */
export const createOneBaseTemplateTypeControllerTemplateTypeEntity = (
    templateTypeEntity: TemplateTypeEntity, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateTypeEntity>> => {
    
    return axios.post(
      `/template-type`,
      templateTypeEntity,options
    );
  }



export const getCreateOneBaseTemplateTypeControllerTemplateTypeEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{data: TemplateTypeEntity}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{data: TemplateTypeEntity}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOneBaseTemplateTypeControllerTemplateTypeEntity>>, {data: TemplateTypeEntity}> = (props) => {
          const {data} = props ?? {};

          return  createOneBaseTemplateTypeControllerTemplateTypeEntity(data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CreateOneBaseTemplateTypeControllerTemplateTypeEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createOneBaseTemplateTypeControllerTemplateTypeEntity>>>
    export type CreateOneBaseTemplateTypeControllerTemplateTypeEntityMutationBody = TemplateTypeEntity
    export type CreateOneBaseTemplateTypeControllerTemplateTypeEntityMutationError = AxiosError<unknown>

    /**
 * @summary Create a single TemplateTypeEntity
 */
export const useCreateOneBaseTemplateTypeControllerTemplateTypeEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{data: TemplateTypeEntity}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getCreateOneBaseTemplateTypeControllerTemplateTypeEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple TemplateTypeEntities
 */
export const getManyBaseTemplateTypeControllerTemplateTypeEntity = (
    params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyTemplateTypeEntityResponseDto>> => {
    
    return axios.get(
      `/template-type`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseTemplateTypeControllerTemplateTypeEntityQueryKey = (params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams,) => {
    return [`/template-type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseTemplateTypeControllerTemplateTypeEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>> = ({ signal }) => getManyBaseTemplateTypeControllerTemplateTypeEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>>
export type GetManyBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple TemplateTypeEntities
 */
export const useGetManyBaseTemplateTypeControllerTemplateTypeEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseTemplateTypeControllerTemplateTypeEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseTemplateTypeControllerTemplateTypeEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>> = ({ signal }) => getManyBaseTemplateTypeControllerTemplateTypeEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseTemplateTypeControllerTemplateTypeEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>>
export type GetManyBaseTemplateTypeControllerTemplateTypeEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple TemplateTypeEntities
 */
export const useGetManyBaseTemplateTypeControllerTemplateTypeEntity = <TData = Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseTemplateTypeControllerTemplateTypeEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a single TemplateTypeEntity
 */
export const updateOneBaseTemplateTypeControllerTemplateTypeEntity = (
    id: string,
    templateTypeEntity: TemplateTypeEntity, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateTypeEntity>> => {
    
    return axios.patch(
      `/template-type/${id}`,
      templateTypeEntity,options
    );
  }



export const getUpdateOneBaseTemplateTypeControllerTemplateTypeEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{id: string;data: TemplateTypeEntity}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{id: string;data: TemplateTypeEntity}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneBaseTemplateTypeControllerTemplateTypeEntity>>, {id: string;data: TemplateTypeEntity}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneBaseTemplateTypeControllerTemplateTypeEntity(id,data,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UpdateOneBaseTemplateTypeControllerTemplateTypeEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneBaseTemplateTypeControllerTemplateTypeEntity>>>
    export type UpdateOneBaseTemplateTypeControllerTemplateTypeEntityMutationBody = TemplateTypeEntity
    export type UpdateOneBaseTemplateTypeControllerTemplateTypeEntityMutationError = AxiosError<unknown>

    /**
 * @summary Update a single TemplateTypeEntity
 */
export const useUpdateOneBaseTemplateTypeControllerTemplateTypeEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError,{id: string;data: TemplateTypeEntity}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUpdateOneBaseTemplateTypeControllerTemplateTypeEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve a single TemplateTypeEntity
 */
export const getOneBaseTemplateTypeControllerTemplateTypeEntity = (
    id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TemplateTypeEntity>> => {
    
    return axios.get(
      `/template-type/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseTemplateTypeControllerTemplateTypeEntityQueryKey = (id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams,) => {
    return [`/template-type/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseTemplateTypeControllerTemplateTypeEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>> = ({ signal }) => getOneBaseTemplateTypeControllerTemplateTypeEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>>
export type GetOneBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single TemplateTypeEntity
 */
export const useGetOneBaseTemplateTypeControllerTemplateTypeEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseTemplateTypeControllerTemplateTypeEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseTemplateTypeControllerTemplateTypeEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseTemplateTypeControllerTemplateTypeEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>> = ({ signal }) => getOneBaseTemplateTypeControllerTemplateTypeEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseTemplateTypeControllerTemplateTypeEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>>
export type GetOneBaseTemplateTypeControllerTemplateTypeEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single TemplateTypeEntity
 */
export const useGetOneBaseTemplateTypeControllerTemplateTypeEntity = <TData = Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseTemplateTypeControllerTemplateTypeEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseTemplateTypeControllerTemplateTypeEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseTemplateTypeControllerTemplateTypeEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const userControllerUpdateClientOfUsers = (
    params: UserControllerUpdateClientOfUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.put(
      `/user`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUserControllerUpdateClientOfUsersMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateClientOfUsers>>, TError,{params: UserControllerUpdateClientOfUsersParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateClientOfUsers>>, TError,{params: UserControllerUpdateClientOfUsersParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdateClientOfUsers>>, {params: UserControllerUpdateClientOfUsersParams}> = (props) => {
          const {params} = props ?? {};

          return  userControllerUpdateClientOfUsers(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateClientOfUsersMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdateClientOfUsers>>>
    
    export type UserControllerUpdateClientOfUsersMutationError = AxiosError<unknown>

    export const useUserControllerUpdateClientOfUsers = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdateClientOfUsers>>, TError,{params: UserControllerUpdateClientOfUsersParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getUserControllerUpdateClientOfUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Retrieve multiple UserEntities
 */
export const getManyBaseUserControllerUserEntity = (
    params?: GetManyBaseUserControllerUserEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyUserEntityResponseDto>> => {
    
    return axios.get(
      `/user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseUserControllerUserEntityQueryKey = (params?: GetManyBaseUserControllerUserEntityParams,) => {
    return [`/user`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseUserControllerUserEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseUserControllerUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseUserControllerUserEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>> = ({ signal }) => getManyBaseUserControllerUserEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseUserControllerUserEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>>
export type GetManyBaseUserControllerUserEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple UserEntities
 */
export const useGetManyBaseUserControllerUserEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseUserControllerUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseUserControllerUserEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseUserControllerUserEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseUserControllerUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseUserControllerUserEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>> = ({ signal }) => getManyBaseUserControllerUserEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseUserControllerUserEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>>
export type GetManyBaseUserControllerUserEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple UserEntities
 */
export const useGetManyBaseUserControllerUserEntity = <TData = Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseUserControllerUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseUserControllerUserEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve a single UserEntity
 */
export const getOneBaseUserControllerUserEntity = (
    id: string,
    params?: GetOneBaseUserControllerUserEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserEntity>> => {
    
    return axios.get(
      `/user/${id}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetOneBaseUserControllerUserEntityQueryKey = (id: string,
    params?: GetOneBaseUserControllerUserEntityParams,) => {
    return [`/user/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOneBaseUserControllerUserEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseUserControllerUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseUserControllerUserEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>> = ({ signal }) => getOneBaseUserControllerUserEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseUserControllerUserEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>>
export type GetOneBaseUserControllerUserEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single UserEntity
 */
export const useGetOneBaseUserControllerUserEntityInfinite = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseUserControllerUserEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseUserControllerUserEntityInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOneBaseUserControllerUserEntityQueryOptions = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(id: string,
    params?: GetOneBaseUserControllerUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneBaseUserControllerUserEntityQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>> = ({ signal }) => getOneBaseUserControllerUserEntity(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOneBaseUserControllerUserEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>>
export type GetOneBaseUserControllerUserEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve a single UserEntity
 */
export const useGetOneBaseUserControllerUserEntity = <TData = Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError = AxiosError<unknown>>(
 id: string,
    params?: GetOneBaseUserControllerUserEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOneBaseUserControllerUserEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOneBaseUserControllerUserEntityQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple RequestHistoryEntities
 */
export const getManyBaseRequestHistoryControllerRequestHistoryEntity = (
    params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyRequestHistoryEntityResponseDto>> => {
    
    return axios.get(
      `/request-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseRequestHistoryControllerRequestHistoryEntityQueryKey = (params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams,) => {
    return [`/request-history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseRequestHistoryControllerRequestHistoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestHistoryControllerRequestHistoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>> = ({ signal }) => getManyBaseRequestHistoryControllerRequestHistoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestHistoryControllerRequestHistoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>>
export type GetManyBaseRequestHistoryControllerRequestHistoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestHistoryEntities
 */
export const useGetManyBaseRequestHistoryControllerRequestHistoryEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestHistoryControllerRequestHistoryEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseRequestHistoryControllerRequestHistoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestHistoryControllerRequestHistoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>> = ({ signal }) => getManyBaseRequestHistoryControllerRequestHistoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestHistoryControllerRequestHistoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>>
export type GetManyBaseRequestHistoryControllerRequestHistoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestHistoryEntities
 */
export const useGetManyBaseRequestHistoryControllerRequestHistoryEntity = <TData = Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestHistoryControllerRequestHistoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestHistoryControllerRequestHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestHistoryControllerRequestHistoryEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple RequestCandidateHistoryEntities
 */
export const getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity = (
    params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyRequestCandidateHistoryEntityResponseDto>> => {
    
    return axios.get(
      `/request-candidate-history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryKey = (params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams,) => {
    return [`/request-candidate-history`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>> = ({ signal }) => getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>>
export type GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestCandidateHistoryEntities
 */
export const useGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>> = ({ signal }) => getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>>
export type GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple RequestCandidateHistoryEntities
 */
export const useGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity = <TData = Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseRequestCandidateHistoryControllerRequestCandidateHistoryEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Retrieve multiple NotificationEntities
 */
export const getManyBaseNotificationControllerNotificationEntity = (
    params?: GetManyBaseNotificationControllerNotificationEntityParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetManyNotificationEntityResponseDTO>> => {
    
    return axios.get(
      `/notification`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetManyBaseNotificationControllerNotificationEntityQueryKey = (params?: GetManyBaseNotificationControllerNotificationEntityParams,) => {
    return [`/notification`, ...(params ? [params]: [])] as const;
    }

    
export const getGetManyBaseNotificationControllerNotificationEntityInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseNotificationControllerNotificationEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseNotificationControllerNotificationEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>> = ({ signal }) => getManyBaseNotificationControllerNotificationEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseNotificationControllerNotificationEntityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>>
export type GetManyBaseNotificationControllerNotificationEntityInfiniteQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple NotificationEntities
 */
export const useGetManyBaseNotificationControllerNotificationEntityInfinite = <TData = Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseNotificationControllerNotificationEntityParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseNotificationControllerNotificationEntityInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetManyBaseNotificationControllerNotificationEntityQueryOptions = <TData = Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError = AxiosError<unknown>>(params?: GetManyBaseNotificationControllerNotificationEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyBaseNotificationControllerNotificationEntityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>> = ({ signal }) => getManyBaseNotificationControllerNotificationEntity(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManyBaseNotificationControllerNotificationEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>>
export type GetManyBaseNotificationControllerNotificationEntityQueryError = AxiosError<unknown>

/**
 * @summary Retrieve multiple NotificationEntities
 */
export const useGetManyBaseNotificationControllerNotificationEntity = <TData = Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError = AxiosError<unknown>>(
 params?: GetManyBaseNotificationControllerNotificationEntityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManyBaseNotificationControllerNotificationEntity>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetManyBaseNotificationControllerNotificationEntityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const notificationControllerUpdateMyNotifications = (
    params: NotificationControllerUpdateMyNotificationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    return axios.put(
      `/notification/update-many`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getNotificationControllerUpdateMyNotificationsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateMyNotifications>>, TError,{params: NotificationControllerUpdateMyNotificationsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateMyNotifications>>, TError,{params: NotificationControllerUpdateMyNotificationsParams}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerUpdateMyNotifications>>, {params: NotificationControllerUpdateMyNotificationsParams}> = (props) => {
          const {params} = props ?? {};

          return  notificationControllerUpdateMyNotifications(params,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerUpdateMyNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerUpdateMyNotifications>>>
    
    export type NotificationControllerUpdateMyNotificationsMutationError = AxiosError<unknown>

    export const useNotificationControllerUpdateMyNotifications = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateMyNotifications>>, TError,{params: NotificationControllerUpdateMyNotificationsParams}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getNotificationControllerUpdateMyNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const notificationControllerDeleteAllMyNotifications = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    return axios.delete(
      `/notification/delete-all`,options
    );
  }



export const getNotificationControllerDeleteAllMyNotificationsMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerDeleteAllMyNotifications>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerDeleteAllMyNotifications>>, TError,void, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerDeleteAllMyNotifications>>, void> = () => {
          

          return  notificationControllerDeleteAllMyNotifications(axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerDeleteAllMyNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerDeleteAllMyNotifications>>>
    
    export type NotificationControllerDeleteAllMyNotificationsMutationError = AxiosError<unknown>

    export const useNotificationControllerDeleteAllMyNotifications = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerDeleteAllMyNotifications>>, TError,void, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getNotificationControllerDeleteAllMyNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const notificationControllerCountMyNotifications = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    return axios.get(
      `/notification/count-my-notifications`,options
    );
  }


export const getNotificationControllerCountMyNotificationsQueryKey = () => {
    return [`/notification/count-my-notifications`] as const;
    }

    
export const getNotificationControllerCountMyNotificationsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError = AxiosError<unknown>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerCountMyNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>> = ({ signal }) => notificationControllerCountMyNotifications({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationControllerCountMyNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>>
export type NotificationControllerCountMyNotificationsInfiniteQueryError = AxiosError<unknown>

export const useNotificationControllerCountMyNotificationsInfinite = <TData = Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError = AxiosError<unknown>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationControllerCountMyNotificationsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerCountMyNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError = AxiosError<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerCountMyNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>> = ({ signal }) => notificationControllerCountMyNotifications({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationControllerCountMyNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>>
export type NotificationControllerCountMyNotificationsQueryError = AxiosError<unknown>

export const useNotificationControllerCountMyNotifications = <TData = Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationControllerCountMyNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationControllerCountMyNotificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Delete a single NotificationEntity
 */
export const deleteOneBaseNotificationControllerNotificationEntity = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.delete(
      `/notification/${id}`,options
    );
  }



export const getDeleteOneBaseNotificationControllerNotificationEntityMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseNotificationControllerNotificationEntity>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseNotificationControllerNotificationEntity>>, TError,{id: string}, TContext> => {
 const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOneBaseNotificationControllerNotificationEntity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOneBaseNotificationControllerNotificationEntity(id,axiosOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type DeleteOneBaseNotificationControllerNotificationEntityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOneBaseNotificationControllerNotificationEntity>>>
    
    export type DeleteOneBaseNotificationControllerNotificationEntityMutationError = AxiosError<unknown>

    /**
 * @summary Delete a single NotificationEntity
 */
export const useDeleteOneBaseNotificationControllerNotificationEntity = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOneBaseNotificationControllerNotificationEntity>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {

      const mutationOptions = getDeleteOneBaseNotificationControllerNotificationEntityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
